planningApp.controller('planningEditCtrl', function (
    $scope,
    $stateParams,
    $state,
    $rootScope,
    $timeout,
    classifierService,
    planningService,
    planData,
    tenderService,
    dateListService,
    unitsService,
    ntFlash,
    validateService,
    formationService,
    uibDatepickerConfig,
    currencyListService,
    oraCodesService,
    OPC_CONFIG,
    loadExternalDataService,
) {
    ntFlash.clean();

    $scope.OPC_CREATE_PLAN_LEGACY = OPC_CONFIG.OPC_CREATE_PLAN_LEGACY;  // Remove legacy after 20.12.2018

    $scope.codes = [];
    oraCodesService.getCodesByCategory('UA')
        .then(c => $scope.codes = c);

    uibDatepickerConfig.minDate = null;

    $scope.isCreateMode = false;

    $scope.plan = planData.data.response;

    console.log('plan', $scope.plan);

    $scope.isCzo = $scope.plan.tender.procurementMethodType === 'centralizedProcurement';
    $scope.hideAddress = !($scope.plan.buyers[0].address.locality);
    $scope.wasCzo = $scope.isCzo;
    $scope.czoList = [];
    $scope.czoSelected = $scope.plan.procuringEntity.identifier.id;
    $scope.isDream = $scope.plan.project ? true : false

    $scope.plan.procuringEntity = angular.copy(OPC_CONFIG.PROCURING_ENTITY);
    delete $scope.plan.procuringEntity.contactPoint;

    const cacheProcurementMethodType = $scope.plan.tender.procurementMethodType;
    const cacheProcuringEntity = $scope.plan.procuringEntity;

    $scope.plan.budget.TaxIncluded = true;
    $scope.isDonor = !!($scope.plan.budget.project && $scope.plan.budget.project.scheme === 'funder_program');
    $scope.funderPrograms = [];
    loadExternalDataService.funderProgramsList().then(programs => {
        $scope.funderPrograms = Array.isArray(programs) ? programs : Object.values(programs || {});
        if ($scope.isDonor) {
            $scope.selectedFunderProgram = $scope.funderPrograms.find(program => {
                const identifier = program.identifier || program;
                return String(identifier.id) === String($scope.plan.budget.project.id) &&
                    String(identifier.scheme || program.scheme || 'funder_program') === String($scope.plan.budget.project.scheme);
            });
        }
    });
    $scope.selectFunderProgram = function (program) {
        if (!program) return;
        const identifier = program.identifier || program;
        $scope.plan.budget.project = {
            id: identifier.id || program.id || '',
            scheme: identifier.scheme || program.scheme || 'funder_program',
            name: identifier.name || identifier.legalName || program.name_uk || program.name || program.description_uk || program.description || ''
        };
    };
    $scope.toggleDonor = function () {
        if (!$scope.isDonor && $scope.plan.budget.project.scheme === 'funder_program') {
            $scope.plan.budget.project = {id: '', name: ''};
        }
    };

    if ($scope.plan.budget.breakdown === undefined) {
        $scope.plan.budget.breakdown = [{
            description: "",
            title: "",
            value: {
                amount: null,
                currency: ""
            }
        }];
    }

    $scope.currencies = currencyListService.getCurrenciesList();

    $scope.currentDate = new Date();

    if (!$scope.plan.additionalClassifications) {
        $scope.plan.additionalClassifications = [];
    }

    if ($scope.plan.items) {
        $scope.plan.items.forEach(function (item) {
            item.unit.name = gettext('единицы измерения');

            if (!item.deliveryDate) {
                item.deliveryDate = {};
            }

            item.deliveryDate.endDateIsOpen = false;
            item.deliveryDate.endDate = item.deliveryDate.endDate == null ? null : new Date(item.deliveryDate.endDate);

            item.classification.data = item.classification;

            if (!item.additionalClassifications) {
                item.additionalClassifications = [];
            }
        });
    }

    unitsService.get()
        .then(function (data) {
            $scope.units = data;
        });

    $scope.open = function ($event, obj, string) {
        $event.preventDefault();
        $event.stopPropagation();

        obj[string + 'IsOpen'] = true;
    };

    $scope.selectDropdown = function (item, code) {
        item.unit.name = code.name;
        item.unit.code = code.code;
    };

    $scope.clearClassificator = function (type, index) {
        $scope.setCurrentClassifierIndex(index);
        classifierService.clearItemTypeClassification($scope.currentClassifierIndex, type);
    };

    $scope.clear = function (target) {
        target.field = "";
        target.data = [];
    };

    $scope.setCurrentClassifierIndex = function (index) {
        if (index === null || index === undefined) {
            $scope.currentClassifierIndex = $scope.plan;
        } else {
            $scope.currentClassifierIndex = $scope.plan.items[index];
        }
    };

    $scope.openClassifier = function (type, index) {
        $scope.setCurrentClassifierIndex(index);
        let codes, checked = [];
        let route = `planning.edit.${type}`;
        if (type === 'cpv') {
            if ($scope.currentClassifierIndex.classification.id) {
                checked = [$scope.currentClassifierIndex.classification.id];
            }

        } else {
            let dkSet = classifierService.getGroupSchemeByType(type);
            let additionalClassifications = ($scope.currentClassifierIndex.additionalClassifications || []).filter((cl) => {
                return dkSet.has(cl.scheme);
            });
            checked = additionalClassifications.map((cl) => {
                return cl.id;
            });

            if (type === 'inn') {
                codes = classifierService.filterSchemes(
                    $scope.currentClassifierIndex.additionalClassifications, ['ATC']).map(
                    (cl) => {
                        return cl.id;
                    })
            } else if (type === 'atc') {
                codes = classifierService.filterSchemes(
                    $scope.currentClassifierIndex.additionalClassifications, ['INN']).map(
                    (cl) => {
                        return cl.id;
                    })
            }
        }
        $state.go(route, {
            checked: checked,
            codes,
        });
    };

    $scope.openBudgetClassifier = (type, index ) => {
        // TODO fix type
        let codes, checked = [];
        let route = `planning.edit.${type}`;

        const year = $scope.plan.budget.breakdown[index].year
        console.log(year)
        if(!year && type==='kpk'){
           ntFlash.error('Виберіть рік')
            return

        } else if(year && type==='kpk') {
            route = `planning.edit.${type}_${year}`;
        }
        $scope.plan.budget.breakdown[index].active = true
        if ($scope.plan.budget.breakdown[index].classification && $scope.plan.budget.breakdown[index].classification.id) {
            checked = [$scope.plan.budget.breakdown[index].classification.id];
        }
        $state.go(route, {
            checked: checked,
            codes,
        });
    }

    $scope.clearBudgetClassificator = (type, index) => {
        if(type !== 'katottg'){
             $scope.plan.budget.breakdown[index].classification = {
                id: "",
                scheme: "",
                description: ""
            }
        } else {
            $scope.plan.budget.breakdown[index].address = {
                countryName: "Україна",
                addressDetails: [{
                        id: "",
                        scheme: "",
                        description: ""
                    }]
            }
        }


    }

    $scope.isMOZ = function (item) {
        return classifierService.isMOZ(item);
    };

    $scope.isINNRequired = function (item) {
        return classifierService.isINNRequired(item);
    };

    $rootScope.$on('addClasificators', function (event, data, type) {
           const budgetClassifier = ['kpk_2019', 'kpk_2020', 'kpk_2021', 'kpk_2022', 'kpk_2023',
            'kpk_2024', 'kpk_2025', 'kpk_2026', 'tkpkmb', ]
                if(budgetClassifier.includes(type) ) {
            const currentBreakdown = $scope.plan.budget.breakdown.find(item => item.active === true)
            if(currentBreakdown){
             currentBreakdown.classification = {
                scheme: data[0].scheme,
                id: data[0].code,
                description: data[0].name
            }
            delete currentBreakdown.active;
            $state.go('planning.edit');
            }

        }
        if('katottg' === type){
            const currentBreakdown = $scope.plan.budget.breakdown.find(item => item.active === true)
            if(currentBreakdown){
                currentBreakdown.address = {
                    countryName: "Україна",
                    addressDetails: [
                        {
                            scheme: data[0].scheme,
                            id: data[0].code,
                            description: data[0].name
                        }
                        ]
                }
                delete currentBreakdown.active;
            }
            $state.go('planning.edit');
        }

        if ($scope.currentClassifierIndex &&  !budgetClassifier.includes(type) && type !== 'katottg' ) {
            let scheme = classifierService.getSchemeByType(type);
            classifierService.clearItemClassification($scope.currentClassifierIndex, scheme);
            classifierService.updateItemClassification($scope.currentClassifierIndex, data);
            $state.go('planning.edit');
        }
    });

    $rootScope.$on('closeClasificators', function () {
        $state.go('planning.edit');
    });

    $scope.addField = function () {
        if ($scope.plan.items === undefined) {
            $scope.plan.items = [];
        }
        $scope.plan.items.push({
            "deliveryDate": {
                "endDate": ""
            },
            "additionalClassifications": [],
            "unit": {
                "code": "",
                "name": gettext('единицы измерения')
            },
            "classification": {},
            "quantity": "",
            "description": ""
        });
    };

    $scope.removeField = function (index) {
        if ($scope.plan.items.length > 0) {
            $scope.plan.items.splice(index, 1);
        }
    };

    $scope.addBreakDownField = function () {
        $scope.plan.budget.breakdown.push({
            description: "",
            title: "",
            value: {
                amount: null,
                currency: ""
            }
        });
    };

    $scope.removeBreakDownField = function (index) {
        if ($scope.plan.budget.breakdown.length > 0) {
            $scope.plan.budget.breakdown.splice(index, 1);
        }
    };

    $scope.showKPKV = true
    $scope.chekKPKV = (index) => {
        const breakdown = $scope.plan.budget.breakdown[index]
        if(breakdown.address){
            const {address, classification, ...rest} = breakdown
            $scope.plan.budget.breakdown[index] = rest
        }

        if(breakdown.classification){
           const {classification, ...rest} = breakdown
            $scope.plan.budget.breakdown[index] = rest
        }
        // if ($scope.plan.budget.breakdown.length > 0) {
        //     const budgetsList = [
        //         'state',
        //         'crimea',
        //         'local',
        //         'fund'
        //     ]
        //      $scope.showKPKV = $scope.plan.budget.breakdown.some((budget) => { return  budgetsList.includes(budget.title)})
        // }
        $scope.showKPKV = true
    }
    // $scope.chekKPKV()

    $scope.publish = function () {
        $scope.plan.procuringEntity.identifier.legalName = $scope.plan.procuringEntity.name;

        $scope.disablePublishBtn = true;
        $scope.$broadcast('show-errors-check-validity');

        if (!$scope.createPlanForm.$valid) {
            ntFlash.error(gettext('Заповніть обов\'язкові поля (підкреслені червоним)'));
            $scope.disablePublishBtn = false;
            return false;
        }

        if (['belowThreshold', 'reporting', ''].includes($scope.plan.tender.procurementMethodType) && $scope.plan.budget.breakdown[0].title === '') {
            delete $scope.plan.budget.breakdown;
        } else {
            if ($scope.plan.tender.procurementMethodType === 'esco' && $scope.plan.budget.breakdown.some(el => el.value.currency !== 'UAH')) {
                $scope.disablePublishBtn = false;
                ntFlash.error(gettext('Валюта джерел фінансування в процедурі ESCO має бути гривня'));
                return false;
            }

            if ($scope.plan.tender.procurementMethodType !== 'esco' && $scope.plan.budget.breakdown.some(el => el.value.currency !== $scope.plan.budget.currency)) {
                $scope.disablePublishBtn = false;
                ntFlash.error(gettext('Валюта усіх джерел фінансування повинна збігатись з валютою плану'));
                return false;
            }

            let sumBreakDownAmount = 0;
            for (const breakdown of $scope.plan.budget.breakdown) {
                sumBreakDownAmount = sumBreakDownAmount + breakdown.value.amount;
            }
            if ($scope.plan.tender.procurementMethodType !== 'esco' && sumBreakDownAmount > $scope.plan.budget.amount) {
                $scope.disablePublishBtn = false;
                ntFlash.error(gettext('Загальна вартість всіх джерел фінансування не може бути більшим за суму плану'));
                return false;
            }
        }

        if ($scope.plan.classification.id === "") {
            ntFlash.error(gettext('Вкажіть класифікатор'));
            $scope.disablePublishBtn = false;
            return false;
        }
        // if ($scope.showKPKV) {
        //     const kpkv = $scope.plan.additionalClassifications.some(
        //         (classification) => classification.scheme === 'КПКВ')
        //     if(!kpkv) {
        //         $scope.disablePublishBtn = false;
        //         ntFlash.error(gettext('Вкажіть класифікатор КПКВ'));
        //         return false;
        //     }
        //
        // }

        // if ($scope.startMonth != "") {
        //     $scope.plan.tender.tenderPeriod.startDate = new Date($scope.startYear, $scope.startMonth - 1);
        // }

        // period validation

        $scope.plan.budget.breakdown.forEach((breakdown) => {
            if(breakdown.title === 'state' && !breakdown.classification){
                  ntFlash.error(gettext('Необхідно заповнити рік та Класифікатор КПК'));
            }

            if(breakdown.title === 'local' || breakdown.title === 'crimea'){
                if(!breakdown.classification || !breakdown.address){
                   ntFlash.error(gettext('Необхідно заповнити Класифікатор КАТОТТГ та Класифікатор ТПКВКМБ'));
                }
            }
        })


        $scope.plan.budget.breakdown = $scope.plan.budget.breakdown.map((breakdown) => {
            if(breakdown.year){
                const {year, ...item} = breakdown
                return item
            }
            return breakdown
        })

        if ($scope.plan.budget.period.startDate &&
            new Date($scope.plan.budget.period.startDate) > new Date($scope.plan.budget.period.endDate)) {
            ntFlash.error(gettext('Період вказано не вірно'));
            $scope.disablePublishBtn = false;
            return false;
        }

        if (!validateService.classifiers($scope.plan.items, $scope.plan.classification, $scope.plan.additionalClassifications)) {
            $scope.disablePublishBtn = false;
            return false;
        }


        if ($scope.createPlanForm.$valid) {
            planningService.edit($state.params.id, $scope.plan)
                .then(function (result) {
                    if (result.data.response) {
                        $timeout(function () {
                            $scope.disablePublishBtn = false;
                            $state.go('planning.overview', {
                                id: result.data.response.id
                            }, {
                                reload: true
                            });
                        }, 2000);
                        ntFlash.success(gettext('План успешно изменен. Не забудьте подписать ключом КЕП'));
                    }

                }, function (err) {
                    console.log(err);
                    $scope.disablePublishBtn = false;
                });
        } else {
            $scope.disablePublishBtn = false;
        }
    };

    $scope.cancel = function () {
        $state.go('planning.overview', {
            id: $state.params.id
        });
    };

    $scope.isProcuringEntityChanged = false;
    $scope.notificationProcuringEntity = function () {
        if (!$scope.isProcuringEntityChanged) {
            ntFlash.error(gettext('Увага! Створити Закупівлю з цього Плану зможе тільки вказана організація'));
            $scope.isProcuringEntityChanged = true;
        }
    };

    $scope.$watch('isCzo', (isCzo) => {
        if (isCzo) {
            classifierService.loadCzo()
                .then(function(data) {
                    console.log('loadCzo data', data);
                    $scope.czoList = data.filter(item => item.active);
                    $scope.plan.tender.procurementMethod = '';
                    $scope.plan.tender.procurementMethodType = 'centralizedProcurement';
                    if ($scope.wasCzo) {
                        $scope.plan.procuringEntity = cacheProcuringEntity;
                    } else {
                        $scope.plan.procuringEntity = {
                            identifier: {
                                scheme: "",
                                id: "",
                                legalName: ""
                            },
                            name: "",
                            kind: "",
                            address: ""
                        };
                    }
                })
                .catch(function(resError) {
                    console.log('loadCzo error', resError);
                })
        } else {
            $scope.plan.tender.procurementMethod = 'open';
            if ($scope.wasCzo) {
                $scope.plan.tender.procurementMethodType = '';
                $scope.plan.procuringEntity = {
                    identifier: {
                        scheme: "",
                        id: "",
                        legalName: ""
                    },
                    name: "",
                    kind: "",
                    address: ""
                };
            } else {
                $scope.plan.tender.procurementMethodType = cacheProcurementMethodType;
                $scope.plan.procuringEntity = cacheProcuringEntity;
            }
        }
    });

    $scope.$watch('hideAddress', (hideAddress) => {

        if (hideAddress) {
            delete $scope.plan.buyers[0].address.locality
            delete $scope.plan.buyers[0].address.postalCode
            delete $scope.plan.buyers[0].address.region
            delete $scope.plan.buyers[0].address.streetAddress
        } else {
            $scope.plan.buyers[0].address = angular.copy(angular.copy(OPC_CONFIG.PROCURING_ENTITY).address)
        }
        // console.log($scope.plan.procuringEntity);
        // console.log($scope.plan.buyers[0]);

    });

    $scope.changedCzoSelected = function(czoSelected) {
        if (czoSelected !== null) {
            for (const czoItem of $scope.czoList) {
                if (czoItem.identifier.id === czoSelected) {
                    $scope.plan.procuringEntity = {
                        address: czoItem.address,
                        kind: 'general',
                        name: (czoItem.name) ? czoItem.name : czoItem.name_uk,
                        name_en: (czoItem.name_en) ? czoItem.name_en : czoItem.name_uk,
                        identifier: {
                            id: czoItem.identifier.id,
                            legalName: czoItem.identifier.legalName,
                            scheme: czoItem.identifier.scheme
                        }
                    };

                    if($scope.plan.procuringEntity.active !== undefined){
                        delete $scope.plan.procuringEntity.active;
                    }

                    if($scope.plan.procuringEntity.marketAdministrator !== undefined){
                        delete $scope.plan.procuringEntity.marketAdministrator;
                    }
                    break;
                }                
            }
        }
    }
});
